import { render, staticRenderFns } from "./4mTargetProcessDetail.vue?vue&type=template&id=5818637e"
import script from "./4mTargetProcessDetail.vue?vue&type=script&lang=js"
export * from "./4mTargetProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5818637e')) {
      api.createRecord('5818637e', component.options)
    } else {
      api.reload('5818637e', component.options)
    }
    module.hot.accept("./4mTargetProcessDetail.vue?vue&type=template&id=5818637e", function () {
      api.rerender('5818637e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/plan/4mTargetProcessDetail.vue"
export default component.exports